import { navigate as originalNavigate } from 'gatsby';

export const navigate = (...args: any[]) => {
  // Call the original function with any arguments
  (originalNavigate as (...args: any[]) => void)(...args);
};
